// extracted by mini-css-extract-plugin
module.exports = {"container":"entity_page-module__container--3vOaV"};